import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { LoginForm } from './components';
import { Actions } from '../../ducks/currentUser';

const { loginUser } = Actions.thunks;

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(form) {
    return this.props.loginUser(form);
  }
  render() {
    const { currentUser } = this.props;
    if (currentUser && currentUser.id) {
      return <Redirect to={'/'} />;
    }
    return <LoginForm onSubmit={this.handleSubmit} />;
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loginUser,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.jsx